import { type ReactNode } from 'react';
import { ActionBoardStoreProvider, usePersistActionBoardStore } from '@/actionBoards/actionBoard.store';
import { AdministrationStoreProvider } from '@/administration/administration.store';
import { AgentBuilderStoreProvider } from '@/agentBuilder/agentBuilder.store';
import { AgentBuilderRunStoreProvider } from '@/agentBuilder/run/agentBuilderRun.store';
import { AnnotationStoreProvider, usePersistAnnotationStore } from '@/annotation/annotation.store';
import {
  sqAdministrationStore,
  sqAnnotationStore,
  sqOperationalizeStatisticsSummaryStore,
  sqStateSynchronizer,
  sqWorkstepsStore,
} from '@/core/core.stores';
import { AddOnToolStoreProvider } from '@/homescreen/addOnTool.store';
import { ImpactReportStoreProvider, usePersistImpactReportStore } from '@/impactReports/impactReports.store';
import { PersistenceProvider } from '@/stores/PersistenceProvider';
import { SystemWarningStoreProvider } from '@/systemWarning/systemWarning.store';
import {
  OperationalizeStatsSummaryProvider,
  usePersistOperationalizeStatisticsSummaryStore,
} from '@/tools/operationalizeStatisticsSummary/operationalizeStatisticsSummary.store';
import { VantageTrendStoreProvider, usePersistVantageTrendStore } from '@/vantage/vantageTrend.store';
import { VantageWorkbookStoreProvider } from '@/vantage/vantageWorkbook.store';
import { WorkstepsStoreProvider } from '@/worksteps/worksteps.store';

export const PersistStores = () => {
  // NOTE: this is where each store that needs to be persisted should be added using its custom hook.
  usePersistImpactReportStore();
  usePersistActionBoardStore();
  usePersistAnnotationStore();
  usePersistVantageTrendStore();
  usePersistOperationalizeStatisticsSummaryStore();

  return null;
};

export const StoreProviders = ({ children }: { children: ReactNode }) => {
  return (
    <PersistenceProvider stateSynchronizer={sqStateSynchronizer}>
      <AdministrationStoreProvider store={sqAdministrationStore}>
        <ImpactReportStoreProvider>
          <VantageWorkbookStoreProvider>
            <ActionBoardStoreProvider>
              <SystemWarningStoreProvider>
                <AnnotationStoreProvider store={sqAnnotationStore}>
                  <AddOnToolStoreProvider>
                    <AgentBuilderRunStoreProvider>
                      <AgentBuilderStoreProvider>
                        <VantageTrendStoreProvider>
                          <WorkstepsStoreProvider store={sqWorkstepsStore}>
                            <OperationalizeStatsSummaryProvider store={sqOperationalizeStatisticsSummaryStore}>
                              <PersistStores />
                              {children}
                            </OperationalizeStatsSummaryProvider>
                          </WorkstepsStoreProvider>
                        </VantageTrendStoreProvider>
                      </AgentBuilderStoreProvider>
                    </AgentBuilderRunStoreProvider>
                  </AddOnToolStoreProvider>
                </AnnotationStoreProvider>
              </SystemWarningStoreProvider>
            </ActionBoardStoreProvider>
          </VantageWorkbookStoreProvider>
        </ImpactReportStoreProvider>
      </AdministrationStoreProvider>
    </PersistenceProvider>
  );
};
